// extracted by mini-css-extract-plugin
export default {"component":"confirmModal__component___F-SFo","alertDialogSlideActions":"confirmModal__alertDialogSlideActions___dLenG","btn-error":"confirmModal__btn-error___SbgD2"};